export default "__VITE_ASSET__CKSJR_QD__"